import React from 'react';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { Widgets } from '../widgets/Widgets';
import { DashboardStorageManagerInstance } from '../DashboardStorageManager';
import WorkListCard from '../../shared/work/list/WorkListCard';
import { ContractorListCard } from '../../my-contractors/contractor/list/ContractorListCard';
import { CompanyUpdateCard } from '../../my-company/company/form/update/CompanyUpdateCard';
import { PsCompanyManagement } from '../../shared/model/PsCompanyManagement';
import { DocumentsCards } from '../../shared/document/list/DocumentsCards';
import { MessagesCard } from '../../shared/message/list/MessagesCard';
import PropTypes from 'prop-types';

export class MyContractorsManagerDashboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dashboardState: null,
        };
    }

    componentDidUpdate(_, prevState) {
        const { dashboardState } = this.state;

        if ( prevState.dashboardState !== dashboardState ) {
            DashboardStorageManagerInstance.saveDocCardFilter('myContractors', dashboardState);
        }
    }

    render() {
        const { breadcrumbs } = this.props;
        const { dashboardState } = this.state;
        const title = `${I18nUtils.tr('TR_INICIO')} - ${I18nUtils.tr('TR_MIS_CONTRATISTAS')}`;

        return (
            <PsPage title={title} breadcrumbs={breadcrumbs}>
                {this.props.children}
                <Widgets
                    onFilter={this.filterDashboardState}
                    companyManagement={PsCompanyManagement.MY_CONTRACTORS}
                />
                <DocumentsCards
                    companyManagement={PsCompanyManagement.MY_CONTRACTORS}
                    dashboardState={dashboardState}
                    saveCardState={this.saveCardState}
                    readCardState={this.readCardState}
                />
                <ContractorListCard
                    saveCardState={(collapsed) => this.saveCardState('contractors', collapsed)}
                    initialCardState={this.readCardState('contractors')}
                />
                <WorkListCard
                    companyManagement={PsCompanyManagement.MY_CONTRACTORS}
                    saveCardState={(collapsed) => this.saveCardState('works', collapsed)}
                    initialCardState={this.readCardState('works')}
                />
                <CompanyUpdateCard
                    saveCardState={(collapsed) => this.saveCardState('company', collapsed)}
                    initialCardState={this.readCardState('company')}
                />
                <MessagesCard
                    canAddMessage={false}
                    canResponseMessage={false}
                    saveCardState={(collapsed) => this.saveCardState('messages', collapsed)}
                    initialCardState={this.readCardState('messages')}
                />
            </PsPage>
        );
    }

    readCardState = (card) => {
        return DashboardStorageManagerInstance.readCard('myContractors', card);
    };

    saveCardState = (card, state) => {
        DashboardStorageManagerInstance.saveCard('myContractors', card, state);
    };

    filterDashboardState = (dashboardState) => {
        this.setState({ dashboardState });
    };
}

MyContractorsManagerDashboard.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
};

MyContractorsManagerDashboard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboards/MyContractorsManagerDashboard.jsx